/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AwsCredential } from './awsCredential';


export interface StorageUnitUploadCredential { 
    awsCredential: AwsCredential;
    /**
     * The AWS KMS key ID that must be used to upload, if applicable
     */
    awsKmsKeyId?: string;
}
